export default __webpack_public_path__ + "static/media/chevron_blue.96d646cf.svg";